module.exports = __webpack_public_path__ + "img/img_gorilla_console.c0197854.png";